import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ThermostatModal.css';
import { PrimaryButton } from '../../../PrimaryButton';
import { ConnectedAddThermostat } from '../AddThermostat';
import { ConnectedThermostatAuthentication } from '../ThermostatAuthentication';
import { Modal } from '../../../Modal';
import { Notification } from '../../../Notification';

export class ThermostatModal extends Component {
  state = {
    thermostatZone: {
      floor: {
        value: '1',
        label: '1',
      },
      suite: '',
      direction: {
        value: 'north',
        label: 'N',
      },
    },
    currentPage: 1,
  };

  handleModalClose() {
    this.props.onRequestClose();
  }

  changeFloor = (floor) => {
    this.setState((state) => ({
      ...state,
      thermostatZone: {
        ...state.thermostatZone,
        floor,
      },
    }));
  };

  changeSuite = (event) => {
    const { name } = event.target;

    // Sanitize text input to only alphanumeric characters not including underscore
    // To allow underscore, change the regex expression to /\W/g
    const value = JSON.stringify(event.target.value)
      .replace(/\W/g, '')
      .toLowerCase();

    this.setState((state) => ({
      ...state,
      thermostatZone: {
        ...state.thermostatZone,
        [name]: value,
      },
    }));
  };

  changeDirection = (direction) => {
    this.setState((state) => ({
      ...state,
      thermostatZone: {
        ...state.thermostatZone,
        direction,
      },
    }));
  };

  shouldSwitchPage = () => {
    const { thermostatError, isRegistering } = this.props;

    if (!isRegistering && !thermostatError) {
      this.setState((state) => ({
        ...state,
        currentPage: 2,
      }));
    }
  };

  handleSuccess = () => {
    const { thermostatError } = this.props;

    if (!thermostatError) {
      this.setState((state) => ({
        ...state,
        currentPage: 3,
      }));
    }
  };

  addNewThermostat = () => {
    this.setState((state) => ({
      ...state,
      currentPage: 1,
      thermostatZone: {
        floor: {
          value: '1',
          label: '1',
        },
        suite: '',
        direction: {
          value: 'north',
          label: 'N',
        },
      },
    }));
  };

  renderModalContent() {
    const {
      currentPage,
      thermostatZone: { floor, suite, direction },
    } = this.state;
    const { newRegisteredThermostat = {} } = this.props;
    const { pin = '', uid_hash: uid = '' } = newRegisteredThermostat;
    switch (currentPage) {
      case 1:
        return (
          <ConnectedAddThermostat
            suite={suite}
            floor={floor}
            direction={direction}
            onSuiteChange={this.changeSuite}
            onFloorChange={this.changeFloor}
            onDirectionChange={this.changeDirection}
            onPinGenerationClick={this.shouldSwitchPage}
          />
        );
      case 2:
        return <ConnectedThermostatAuthentication uid={uid} pin={pin} onSuccess={this.handleSuccess} />;
      case 3:
        return this.renderThirdPage();
      default:
        return null;
    }
  }

  renderThirdPage() {
    const { display_name: displayName } = this.props.newRegisteredThermostat;

    return (
      <div className="thermostat-modal__page">
        <div className="thermostat-modal__text">
          <div className="thermostat-modal__title-text">Finished!</div>
        </div>
        <div className="thermostat-modal__success thermostat-modal__text-group">
          <Notification message={`Thermostat added successfully. Settings pushed to ${displayName}.`} type="success" />
        </div>
        <div className="thermostat-modal__add-new-button-wrapper">
          <PrimaryButton icon="add-icon" label="Add New Thermostat" onClick={this.addNewThermostat} fullWidth={true} />
        </div>
        <button
          id="view-thermostats"
          className="thermostat-modal__button--white"
          onClick={() => this.handleModalClose()}
        >
          <div className="thermostat-modal__button-text">View Thermostats</div>
        </button>
      </div>
    );
  }

  render() {
    return (
      <Modal>
        <div className="thermostat-modal-overlay">
          <div className="thermostat-modal">
            <div className="thermostat-modal__title">
              <div className="thermostat-modal__title-back-button-div" />
              <div className="thermostat-modal__title-div">
                <div className="thermostat-modal__title-text">Add Thermostat</div>
                <span className="thermostat-modal__title-text--mobile">&nbsp;</span>
                <div className="thermostat-modal__title-text">(Step {this.state.currentPage} of 3)</div>
              </div>
              <div className="thermostat-modal__title-close-button-div">
                <input
                  id="close-button"
                  className="thermostat-modal__close-button"
                  type="button"
                  onClick={() => this.handleModalClose()}
                />
              </div>
            </div>
            {this.renderModalContent()}
          </div>
        </div>
      </Modal>
    );
  }
}

ThermostatModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
  thermostatError: PropTypes.string,
  newRegisteredThermostat: PropTypes.shape({
    pin: PropTypes.string,
    uid_hash: PropTypes.string,
    direction: PropTypes.string,
    unit_number: PropTypes.string,
    display_name: PropTypes.string,
    floor_number: PropTypes.number,
    building_slug: PropTypes.string,
    thermostat_type: PropTypes.string,
    building_section: PropTypes.string,
  }),
  isRegistering: PropTypes.bool,
};

ThermostatModal.defaultProps = {
  thermostatError: undefined,
  isRegistering: false,
};

export function mapStateToProps(state) {
  return {
    thermostatError: state.thermostatReducer.error,
    newRegisteredThermostat: state.thermostatReducer.newRegisteredThermostat,
    isRegistering: state.thermostatReducer.isRegistering,
  };
}

const ConnectedThermostatModal = connect(mapStateToProps)(ThermostatModal);
export { ConnectedThermostatModal };
